import styled from 'styled-components'

import { helpers } from 'styles'

export const OriginalCurrency = styled.div`
	font-size: ${helpers.font.size.baseSmall};
	text-transform: uppercase;
	color: ${helpers.color.textMuted};
`
